import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getDvSourceImageUrl, toCssUrlValue } from "../../functions/themeAssets";

/**
 * "How to Play" rules modal, opened from the glowing "?" button on GamePage.
 * Content mirrors the (unrouted) UserRules page — admin's `rules` bullets,
 * dynamic text color — plus the admin's desktop background image behind it.
 */
export default function RulesModal({ open, onClose }) {
  const { data: themeData } = useSelector((state) => state.theme);

  const bgUrl = useMemo(() => {
    const key = themeData?.background_desk;
    return key ? getDvSourceImageUrl(key) : "";
  }, [themeData]);

  const textColor = useMemo(() => {
    const raw = themeData?.landing_page_title_color ?? themeData?.textcolor;
    if (raw == null || raw === "") return undefined;
    const c = String(raw).trim();
    return c || undefined;
  }, [themeData]);

  const rules = useMemo(() => {
    const raw = themeData?.rules;
    if (Array.isArray(raw)) return raw.filter((item) => String(item ?? "").trim() !== "");
    return [];
  }, [themeData]);

  if (!open) return null;

  return (
    <div className="mf-rules-overlay" role="dialog" aria-modal="true" aria-label="How to play" onClick={onClose}>
      <div
        className="mf-rules-modal"
        style={{
          backgroundImage: bgUrl ? toCssUrlValue(bgUrl) : undefined,
          color: textColor,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="mf-rules-close" onClick={onClose} aria-label="Close">
          &times;
        </button>
        <div className="mf-rules-content">
          <h2 className="mf-rules-heading">How to Play</h2>
          {rules.length > 0 ? (
            <ul className="mf-rules-list">
              {rules.map((rule, i) => (
                <li key={i}>{rule}</li>
              ))}
            </ul>
          ) : (
            <p className="mf-rules-empty">No rules configured yet.</p>
          )}
        </div>
      </div>
    </div>
  );
}
